import { connect } from 'react-redux'
import { selectNoteDraft } from 'ducks/drafts'
import View from './view'

const select = state => ({
  draft: selectNoteDraft(state),
})

export default connect(select)(View)
